module.exports = __webpack_public_path__ + "static/media/Element_13_treatments.61fdcf31.svg";